import get from 'lodash.get';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectGroupOptions } from 'services/groups/selectors';
// @ts-ignore
import { makeSelectPersonGroupIds } from 'services/groupPeople/selectors';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';
import { selectMyTimesheetEntries } from 'services/myTimesheetEntries/selectors';

const selectMyTimesheetFilteredGroups = createDeepEqualSelector(
    selectGroupOptions,
    makeSelectPersonGroupIds(),
    makeSelectQueryStringValue('myTimesheetEntryUuid'),
    selectMyTimesheetEntries,
    (
        groupOptions,
        groupIds: number[],
        myTimesheetEntryUuid: string | undefined,
        myTimesheetEntries
    ) => {
        if (!groupIds || !groupIds.length) {
            return groupOptions;
        }

        /*
        Edge case, where user might have created timesheet entry with Group X, then someone moved him to Group Y.
        This would let Group X be selected as an option as the original data is related to that group.
        */
        const currentTimesheetEntryGroupId: number | null = myTimesheetEntryUuid
            ? get(myTimesheetEntries, [myTimesheetEntryUuid, 'groupId'])
            : null;

        return groupOptions.filter(
            (option) =>
                groupIds.includes(Number(option.value)) ||
                (currentTimesheetEntryGroupId &&
                    Number(option.value) === currentTimesheetEntryGroupId)
        );
    }
);

export { selectMyTimesheetFilteredGroups };
